import { Routes, Route, NavLink } from 'react-router-dom';
import { useSession } from '@/lib/session';
import BriefToday from '@/pages/BriefToday';
import BriefsArchive from '@/pages/BriefsArchive';
import BriefDetail from '@/pages/BriefDetail';
import Feed from '@/pages/Feed';
import Stocks from '@/pages/Stocks';
import Digital from '@/pages/Digital';
import Entities from '@/pages/Entities';
import EntityDetail from '@/pages/EntityDetail';
import Usage from '@/pages/Usage';
import Debug from '@/pages/Debug';
import NotFound from '@/pages/NotFound';

// HMH Watch, re-hosted inside the portal shell at /hmhwatch. Pages are the cloned HMHWatch views;
// their data flows through the portal BFF reverse-proxy (lib/queries -> /api/hmhwatch/** -> HMHWatch
// Api), so there's no second login. Usage/Debug are admin-only (the proxy carries the X-Portal-Trusted
// secret + an admin HMHWatch login, and the portal session reports isLan=isAdmin so the pages enable).
export default function HmhWatchApp() {
  const { data: session } = useSession();
  const isAdmin = !!session?.isAdmin;

  const tabs = [
    { to: '/hmhwatch', label: 'Today', end: true },
    { to: '/hmhwatch/briefs', label: 'Briefs', end: false },
    { to: '/hmhwatch/feed', label: 'Feed', end: false },
    { to: '/hmhwatch/stocks', label: 'Stocks', end: false },
    { to: '/hmhwatch/digital', label: 'Digital', end: false },
    { to: '/hmhwatch/entities', label: 'Entities', end: false },
    ...(isAdmin
      ? [
          { to: '/hmhwatch/usage', label: 'Usage', end: false },
          { to: '/hmhwatch/debug', label: 'Debug', end: false },
        ]
      : []),
  ];

  return (
    <div>
      <nav className="mb-6 flex flex-wrap gap-1 border-b border-border" aria-label="HMH Watch">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              'px-3 py-2 text-sm font-(family-name:--font-ui) border-b-2 -mb-px transition-colors ' +
              (isActive ? 'border-accent text-text' : 'border-transparent text-muted hover:text-text')
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Routes>
        <Route index element={<BriefToday />} />
        <Route path="briefs" element={<BriefsArchive />} />
        <Route path="briefs/:date" element={<BriefDetail />} />
        <Route path="feed" element={<Feed />} />
        <Route path="stocks" element={<Stocks />} />
        <Route path="digital" element={<Digital />} />
        <Route path="entities" element={<Entities />} />
        <Route path="entities/:id" element={<EntityDetail />} />
        <Route path="usage" element={<Usage />} />
        <Route path="debug" element={<Debug />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}
